<template>
  <modal ref='modal' class="settings">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('folders_list.file_collection')}}</h5>
      <a :href="efortlessCollection()" target="_blank" class="own-tooltip own-tooltip-bottom video-link" :data-tooltip="$t('folders_list.click_here_to_watch')"><img src="../../../assets/video.svg" /></a>
    </template>

    <template #body>
      <h2>{{$t('folders_list.how_does_it_work')}}</h2>

      <ol>
        <li>{{$t('folders_list.copy_links')}}</li>
        <li>{{$t('folders_list.share_it')}}</li>
        <li>{{$t('folders_list.files_arrive')}}</li>
      </ol>

      <div class="copy-to-clipboard-wrapper">
        <input type="text" name="public_link"
               id="public_link"
               :value="uploadUrl"
               disabled="disabled"
               class="public_link input-link-to-clipboard">

        <a href="" class="btn btn-outline-primary float-right copy-link-to-clipboard" @click.prevent="copyToClipboard($event, '.input-link-to-clipboard')">
          <i class="fas fa-link"></i>
          {{ $t('folder_show.settings.upload_link_button') }}
        </a>
      </div>

      <div class="copy-to-clipboard-wrapper email-wrapper">
        <input type="text" name="public_email"
               id="public_email"
               :value="ingestionEmail"
               disabled="disabled"
               class="email-to-clipboard ingestion-email">

        <a href="" class="btn btn-outline-primary float-right copy-email-to-clipboard" @click.prevent="copyToClipboard($event, '.email-to-clipboard')">
          <i class="far fa-envelope"></i>
          {{ $t('folder_show.settings.reply_email_button') }}
        </a>
      </div>

      <p>
        {{$t('folders_list.bonus_tips')}}
        <span>{{$t('folders_list.forward_emails')}}</span>
        <span>{{$t('folders_list.receive_files')}}</span>
      </p>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'

  export default {
    components: {
      modal: _modal,
    },
    data() {
      return {
        folder: {},
      }
    },
    computed: {
      ingestionEmail() {
        return `files+${this.folder.uuid}@mail.relatico.com`
      },
      uploadUrl() {
        return window.location.origin + this.$router.resolve({ name: 'public_folder', params: { uuid: this.folder.uuid } }).href
      }
    },
    methods: {
      open(folder) {
        this.folder = Object.assign({}, folder)
        this.$refs.modal.open()
      },
      efortlessCollection(){
        if(this.locale === 'de')
          return 'https://relatico.wistia.com/medias/ohar11wazr'
        return 'https://relatico.wistia.com/medias/d2ptk6u0x0'
      }
    }
  }
</script>

<style lang='sass' scoped>
  .settings
    .modal-dialog
      max-width: 700px
      text-align: left
    h2
      font-size: 16px
      color: #000
      font-weight: bold
      padding-left: 20px
    ol
      list-style: none
      padding: 0 0 0 20px
      margin: 0 0 20px 0
      li
        font-size: 14px
        color: #000
        line-height: 24px
    .copy-to-clipboard-wrapper
      padding: 0 20px
      display: flex
      margin-bottom: 15px
      input
        flex: 1
        margin-right: 10px
        padding-left: 5px
        max-width: 530px
      &.email-wrapper
        margin-bottom: 5px
    p
      font-size: 12px
      padding-left: 20px
      span
        display: block
  .video-link
    margin: 4px 10px
</style>
